var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPairedIcon = function SvgPairedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_x5F_link"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1779 777a387 387 0 0 0-360-535 386 386 0 0 0-275 114L959 541a64 64 0 1 0 90 90l185-185a259 259 0 0 1 369 0 259 259 0 0 1 0 369l-185 185a64 64 0 1 0 91 90l185-185c37-37 65-80 85-128zM1090 1418a64 64 0 0 0-90 0l-185 185a259 259 0 0 1-369 0 259 259 0 0 1 0-369l185-185a64 64 0 1 0-91-90l-185 185a387 387 0 0 0 129 635 387 387 0 0 0 421-86l185-185c25-24 25-65 0-90z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M849 1290l444-443a64 64 0 1 0-91-91l-444 444a64 64 0 1 0 91 90z"
  }))));
};
export default __webpack_public_path__ + "static/media/paired_icon.c41d6a86.svg";
export { SvgPairedIcon as ReactComponent };